import React from "react"
import Contact from "../components/Contact/Contact"
import Advantage from "../components/Frontpage/Advantage/Advantage"
import Goods from "../components/Frontpage/Goods/Goods"
import Header from "../components/Frontpage/Header/Header"
import Layout from "../components/Layout/Layout"
import Logo from "../components/FrontPage/Logo/Logo"
import '../style/global.css'
import Video from "../components/Frontpage/Videos/Video"

export default function Home() {
  return(
    <Layout>
      <Header/>
      <Video/>
      <Goods/>
      <Advantage/>
      <Logo/>
      <Contact/>
    </Layout>
  )
}
